<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="selectedIndex"
    ref="gc-base-layout"
    class="intake-estimate"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Intake Estimate'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode == 'create'
            ? 'Create Intake Estimate'
            : 'Intake Estimate'
        "
        :secondaryLabel="
          baseView.mode != 'create' ? model.Description : undefined
        "
        v-if="loaded"
      />
    </template>

    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? model : {}"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form" v-show="!gridExpand">
        <div class="view-card responsive-paddings">
          <gc-form
            :formOptions="{
              gcLabelLocation: 'left',
            }"
            :formItems="getHeaderFormItems"
            :isNormal="true"
            :data-model="loaded ? model : {}"
            :formMode="baseView.mode"
            :fromFrom="'gc-header-form'"
            ref="gc-header-form"
            :valueChangeCallBack="headerFormValueChanged"
            :checkValid="isValid"
            :validationGroup="'gc-header-form'"
            :scrollingEnabled="false"
            :formContentReady="onHeaderFormContentReady"
            :formHeight="75"
          ></gc-form>
        </div>
      </div>

      <div class="gc-details-grid" v-if="loaded">
        <dx-data-grid
          @toolbar-preparing="toolbarPreparing($event)"
          :columns="getColumns"
          :data-source="getDataSource"
          :height="getGridHeight"
          @cell-prepared="onCellPrepared"
          :ref="'dx-data-grid-comp'"
          :key-expr="'VarietyCode'"
          @editor-preparing="onEditorPreparing"
          :twoWayBindingEnabled="false"
          :repaintChangesOnly="true"
          :focusedRowEnabled="baseView.mode != 'review'"
          :columnChooser="{
            enabled: false,
          }"
          :onFocusedCellChanging="onFocusedCellChanging"
        >
          <DxEditing
            :allow-updating="baseView.mode != 'review'"
            :allow-deleting="false"
            mode="cell"
            :new-row-position="'last'"
          />

          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />
        </dx-data-grid>
      </div>
    </div>

    <!-- Apply Size Profile -->
    <gc-popup
      :popup-visible="visibleApplySizeProfile"
      popup-title="Apply Size Profile"
      :back-button-function="closeApplySizeProfile"
      :popup-height="200"
      :saveButtonConfig="ApplySizeProfileConfig.save"
      :backButtonConfig="ApplySizeProfileConfig.back"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getApplySizeProfileFormItems"
          :isNormal="true"
          :data-model="ApplySizeProfileModel"
          :formMode="'create'"
          :fromFrom="'gc-header-form-d-a'"
          :formHeight="70"
          :validationGroup="'gc-header-form-d-a'"
        ></gc-form>
      </div>
    </gc-popup>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import { IntakeEstimateService } from "../../../_services/api/purchasing/intake-estimate/intake-estimate.service";
import ArrayStore from "devextreme/data/array_store";
import validationEngine from "devextreme/ui/validation_engine";
import { IntakeSeasonService } from "../../../_services/api/settings/inventory/intake-season.service";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  data() {
    return {
      backButtonRoute: "/intake-estimate",
      loaded: false,
      gridExpand: false,
      isValid: false,
      model: {
        Status: "N",
        Description: undefined,
        Season: null,
        EstimateDate: undefined,
        EstimateOwner: undefined,
        TotalKg: undefined,
      },
      headerFormHeight: 0,
      columns: [],

      dataSource: new ArrayStore({
        key: "VarietyCode",
        data: [],
      }),
      selectedSeason: undefined,
      visibleApplySizeProfile: false,
      ApplySizeProfileModel: {
        Season: undefined,
      },
    };
  },
  created() {
    this.onInitialized();
  },
  methods: {
    // This function is used to close the Apply Size Profile modal (or any similar component)
    // and reset the Season property of the ApplySizeProfileModel object.
    closeApplySizeProfile() {
      // Set the visibility of the Apply Size Profile modal (or similar) to false, effectively hiding it.
      this.visibleApplySizeProfile = false;

      // Reset the Season property of the ApplySizeProfileModel object to undefined.
      this.ApplySizeProfileModel.Season = undefined;
    },
    // This function is used to open the Apply Size Profile modal (or any similar component).
    openApplySizeProfile() {
      // Set the visibility of the Apply Size Profile modal (or similar) to true, effectively showing it.
      this.visibleApplySizeProfile = true;
    },
    // This function is triggered when the editor is preparing to make changes.
    onEditorPreparing(e) {
      // Check if the parent type is a data row.
      if (e.parentType == "dataRow") {
        // If the data field does not exist in the row data, disable the editor.
        if (!(e.dataField in e.row.data)) e.editorOptions.disabled = true;
      }
    },

    // This function is triggered when a cell is prepared.
    onCellPrepared(e) {
      // If the row type is data, perform the following operations.
      if (e.rowType == "data") {
        // If the column data field does not exist in the data, remove the "gc-editable-cell-color" class from the cell element.
        if (!(e.column.dataField in e.data)) {
          e.cellElement.classList.remove("gc-editable-cell-color");
        }
      }

      // If the mode is "review", remove the "gc-editable-cell-color" class from the cell element.
      if (e.rowType == "data") {
        if (this.baseView.mode == "review")
          e.cellElement.classList.remove("gc-editable-cell-color");
        else if (e.column.dataField in e.data)
          e.cellElement.classList.add("gc-editable-cell-color");
      }
    },

    // This function is triggered when the focused cell is changing.
    onFocusedCellChanging(e) {
      // Check if the tab key was pressed without the shift key.
      if (e.event.code == "Tab" && e.event.shiftKey == false) {
        let dataField = e.columns[e.newColumnIndex].dataField;
        // If the data field does not exist in the row data, increment the new column index.
        if (!(dataField in e.rows[e.newRowIndex].data)) {
          e.newColumnIndex += 1;

          let colCount = e.columns.length;
          // Check if the next consecutive columns also have disabled editing.
          for (let i = e.newColumnIndex; i < colCount; i++) {
            dataField = e.columns[e.newColumnIndex].dataField;
            // If the data field does not exist in the row data, increment the new column index.
            if (!(dataField in e.rows[e.newRowIndex].data)) {
              e.newColumnIndex += 1;
            } else {
              break;
            }
          }
        }
        // Check if the tab key was pressed with the shift key.
      } else if (e.event.code == "Tab" && e.event.shiftKey == true) {
        let dataField = e.columns[e.newColumnIndex].dataField;
        // If the data field does not exist in the row data, decrement the new column index.
        if (!(dataField in e.rows[e.newRowIndex].data)) {
          e.newColumnIndex -= 1;

          let colCount = e.columns.length;
          // Check if the next consecutive columns also have disabled editing.
          // eslint-disable-next-line for-direction
          for (let i = e.newColumnIndex; i < colCount; i--) {
            dataField = e.columns[e.newColumnIndex].dataField;
            // If the data field does not exist in the row data, decrement the new column index.
            if (!(dataField in e.rows[e.newRowIndex].data)) {
              e.newColumnIndex -= 1;
            } else {
              break;
            }
          }
        }
      }
    },
    toolbarPreparing() {},

    // This function checks the validation of the header form.
    async checkHeaderFormValidation() {
      // Validate the toolbar form.
      let toorBarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );
      // Validate the header form.
      let headerform = await validationEngine.validateGroup("gc-header-form");
      // If either form is not valid, display the validation summary.
      if (!toorBarForm.isValid || !headerform.isValid)
        this.displayValidationSummary(
          toorBarForm.brokenRules.concat(headerform.brokenRules)
        );
      else {
        // Prepare the payload for the intake estimate.
        var payload = {
          Description: this.model.Description,
          Season: this.model.Season,
          EstimateDate: this.model.EstimateDate,
          EstimateOwner: this.model.EstimateOwner,
          TotalKg: this.model.TotalKg,
          EstimateVarieties: this.getEstimateVarieties(),
          EstimateSizes: this.getEstimateSizes(),
        };

        if (this.baseView.mode == "edit") payload.RecordId = this.baseView.id;

        // Show the loading indicator.
        this.showLoading(true);
        // Save the intake estimate.
        await IntakeEstimateService.saveIntakeEstimate(payload)
          .then((res) => {
            // If the response is successful, continue showing the loading indicator.
            if (res) this.showLoading(false);

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: "/intake-estimate/review/" + res.data.RecordId,
            });
          })
          .catch((err) => {
            // If there is an error, continue showing the loading indicator and display the server error.
            this.showLoading(false);
            this.displayServerError(err, "Intake Estimate Save Failed");
          });
      }
    },

    // This function gets the estimate varieties.
    getEstimateVarieties() {
      // Initialize an empty array.
      var obj = [];
      // Iterate over each element in the data source array.
      this.dataSource._array.forEach((element) => {
        // If any of the specified properties exist, push a new object to the array.
        if (
          element.StartDate ||
          element.EndDate ||
          element.LiftPcnt ||
          element.TotalKg
        ) {
          var item = {
            VarietyCode: element.VarietyCode,
            StartDate: element.StartDate,
            EndDate: element.EndDate,
            LiftPcnt: element.LiftPcnt,
            TotalKg: element.TotalKg,
          };

          if (this.baseView.mode != "create") {
            item.RecordId = element.RecordId;
            item.IntakeEstimateRecordID = element.IntakeEstimateRecordID;
          }
          obj.push(item);
        }
      });

      // Return the array.
      return obj;
    },

    // This function gets the estimate sizes.
    getEstimateSizes() {
      // Initialize an empty array.
      var obj = [];
      // Iterate over each element in the data source array.
      this.dataSource._array.forEach((element) => {
        // Iterate over each key in the element.
        for (var key in element) {
          var pattern = /RecordId/g;
          // If the key is not one of the specified properties and the key exists, push a new object to the array.
          if (
            key != "VarietyCode" &&
            key != "StartDate" &&
            key != "EndDate" &&
            key != "LiftPcnt" &&
            key != "TotalKg" &&
            key != "IntakeEstimateRecordID" &&
            pattern.test(key) == false
          ) {
            if (element[key]) {
              var item = {
                VarietyCode: element.VarietyCode,
                SizeCode: key.toString(),
                TotalKg: element[key],
              };

              if (this.baseView.mode != "create") {
                item.RecordId = element[key + "_RecordId"];
                item.IntakeEstimateRecordID = element.IntakeEstimateRecordID;
              }
              obj.push(item);
            }
          }
        }
      });

      // Return the array.
      return obj;
    },

    // This function is triggered when the header form content is ready.
    onHeaderFormContentReady(e) {
      // Get all elements with the class "gc-header-form".
      const headerForm = document.querySelectorAll(".gc-header-form");
      // Set the height of the header form.
      this.headerFormHeight = headerForm[0].clientHeight;

      // If the event exists and the mode is not "review", set the focus to the "DateIn" editor after a delay.
      if (e && this.baseView.mode != "review") {
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("DateIn"))
            headerToolBarForm.getEditor("DateIn").instance().focus();
        }, 500);
      }
    },

    // This function is triggered when the value of the header form changes.
    headerFormValueChanged(isValid, brokenRules) {
      // Set the validity to false.
      this.isValid = false;
      // If the form is not valid, display the validation summary.
      if (!isValid) this.displayValidationSummary(brokenRules);
    },

    // This function is triggered when the back button is clicked.
    backButtonFunction() {
      // Navigate to the route specified by the back button.
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          // Reset the data view type.
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },

    // This function is triggered when the component is initialized.
    async onInitialized() {
      // Get the available variety size and the variety size from the service, then create the data source.
      await this.getAlmondcoIntakeAvailableVarietySize();
      var varietySize = await this.getAlmondcoIntakeVarietySize();
      this.createDataSource(varietySize);

      // If the mode is "create", set the loaded flag to true.
      if (this.baseView.mode == "create") {
        this.loaded = true;
      } else {
        // Otherwise, get the intake estimate, intake estimate variety, and intake estimate size from the service.
        await IntakeEstimateService.getAlmondcoIntakeEstimate(
          this.baseView.id
        ).then((res) => {
          if (res.data.value.length > 0) {
            var data = res.data.value[0];
            // Update the model with the data from the response.
            this.model.Description = data.Description;
            this.model.Season = data.Season;
            this.model.EstimateDate = data.EstimateDate;
            this.model.EstimateOwner = data.EstimateOwner;
            this.model.TotalKg = data.TotalKg;
            this.model.DateChanged = data.DateChanged;
            this.model.DateCreated = data.DateCreated;
            this.model.ChangedBy = data.ChangedBy;
            this.model.CreatedBy = data.CreatedBy;
          }
        });

        await IntakeEstimateService.getAlmondcoIntakeEstimateVariety(
          this.baseView.id
        ).then((res) => {
          // For each element in the response, update the data source with the variety code and the data from the element.
          res.data.value.forEach((element) => {
            this.dataSource.update(element.VarietyCode, {
              StartDate: new Date(element.StartDate),
              EndDate: new Date(element.EndDate),
              LiftPcnt: element.LiftPcnt,
              TotalKg: element.TotalKg,
              RecordId: element.RecordId,
            });
          });
        });

        await IntakeEstimateService.getAlmondcoIntakeEstimateSize(
          this.baseView.id
        ).then((res) => {
          // For each element in the response, update the data source with the variety code and the size and total kg from the element.
          res.data.value.forEach((element) => {
            var obj = {};
            var size = element.SizeCode;
            obj[size] = element.TotalKg;
            obj["IntakeEstimateRecordID"] = element.IntakeEstimateRecordID;
            obj[size + "_RecordId"] = element.RecordId;
            this.dataSource.update(element.VarietyCode, obj);
          });
        });

        // Set the loaded flag to true.
        this.loaded = true;
      }
    },

    // This function gets the available variety size from the IntakeEstimateService.
    async getAlmondcoIntakeAvailableVarietySize() {
      // Call the getAlmondcoIntakeAvailableVarietySize method from the service and wait for the response.
      await IntakeEstimateService.getAlmondcoIntakeAvailableVarietySize().then(
        (res) => {
          // For each element in the response data value, perform the following operations.
          // alphabetical order
          var data = res.data.value.sort((a, b) => {
            if (a.Size < b.Size) {
              return -1;
            }
            if (a.Size > b.Size) {
              return 1;
            }
            return 0;
          });

          data.forEach((element) => {
            // Push a new object to the columns array with properties set based on the element.
            this.columns.push({
              caption: element.Size, // Set the caption to the size of the element.
              dataField: element.Size, // Set the data field to the size of the element.
              dataType: "number", // Set the data type to number.
              allowEditing: true, // Allow editing of this field.
              showEditorAlways: false, // Do not always show the editor.
              minWidth: 75, // Set the minimum width of the column to 75.
              // If the mode is not "review", set the cssClass to "gc-editable-cell-color", otherwise set it to undefined.
              cssClass:
                this.baseView.mode != "review"
                  ? "gc-editable-cell-color"
                  : undefined,
              format: "##,###,###,###,##0", // Set the format for the number.
              editorOptions: {
                format: "##,###,###,###,##0", // Set the format for the editor.
                onFocusIn: (e) => {
                  // If the event target has a select method, call it.
                  if (e.event.target.select) e.event.target.select();
                },
              },
              setCellValue: async (newData, value, currentRowData) => {
                var dataField = element.Size; // Set the data field to the size of the element.
                newData[dataField] = value; // Set the new data to the value.
                // Calculate the new total kg by subtracting the current data field from the total kg and adding the value.
                newData.TotalKg =
                  currentRowData.TotalKg - currentRowData[dataField] + value;
                // Update the total kgs with the old and new total kg.
                this.updateTotalKgs(currentRowData.TotalKg, newData.TotalKg);

                return newData; // Return the new data.
              },
            });
          });
        }
      );
    },

    // This function updates the total kilograms in the form.
    updateTotalKgs(oldValue, newValue) {
      // Get the form instance from the component's refs.
      var form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;

      // Check if the form instance exists.
      if (form) {
        // Get the editor for the "TotalKg" field.
        var editor = form.getEditor("TotalKg");

        // Check if the editor exists.
        if (editor) {
          // Get the current value of "TotalKg".
          let totalKg = editor.option("value");

          // Update the value of "TotalKg" by subtracting the old value and adding the new value.
          // This is done to reflect the changes in the total kilograms based on the changes in the individual entries.
          if (oldValue != undefined)
            editor.option("value", totalKg - oldValue + newValue);
          else editor.option("value", newValue);
        }
      }
    },

    // This function gets the variety size from the IntakeEstimateService.
    async getAlmondcoIntakeVarietySize() {
      // Call the getAlmondcoIntakeVarietySize method from the service and wait for the response.
      return await IntakeEstimateService.getAlmondcoIntakeVarietySize().then(
        (res) => {
          // Return the value from the response data.
          return res.data.value;
        }
      );
    },

    // This function creates a data source from the given variety size.
    createDataSource(varietySize) {
      // Group the variety size items by code.
      let groupedItems = this.groupByCode(varietySize);

      // For each key in the grouped items, perform the following operations.
      for (var key in groupedItems) {
        // Create a new object with the key and some default properties.
        var obj = {
          VarietyCode: key,
          StartDate: "",
          EndDate: "",
          LiftPcnt: "",
          TotalKg: "",
        };

        // For each element in the grouped items, add a new property to the object with the size as the key and null as the value.
        groupedItems[key].forEach((element) => {
          var size = element.Size;
          obj[size] = null;
        });

        // Insert the object into the data source.
        this.dataSource.insert(obj);
      }
    },

    // This function groups an array of items by code.
    groupByCode(array) {
      // eslint-disable-next-line no-unused-vars
      var groupedItems = [];
      return array.reduce((groupedItems, item) => {
        (groupedItems[item.Code] = groupedItems[item.Code] || []).push(item);
        return groupedItems;
      }, {});
    },

    // This function is triggered when a season is clicked.
    onSeasonClicked(e) {
      // Set the selected season to the clicked item's data.
      this.selectedSeason = e.itemData;

      // // Get the instance of the form component.
      // var instance =
      //   this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;

      // // Get the editor for the "EstimateDate" field.
      // var editor = instance.getEditor("EstimateDate");

      // // Set the minimum and maximum options for the editor to the start and end dates of the selected season.
      // editor.option("min", new Date(this.selectedSeason.StartDate));
      // editor.option("max", new Date(this.selectedSeason.EndDate));
    },
    // This function is used to apply a size profile.
    async onApplySizeProfile() {
      // Show the loading indicator.
      this.showLoading(true);

      // Call the ApplySizeProfile method from the IntakeEstimateService.
      await IntakeEstimateService.ApplySizeProfile(
        this.ApplySizeProfileModel.Season
      )
        .then((res) => {
          // Extract the data from the response.
          var data = res.data.value;

          // Iterate over each element in the data array.
          data.forEach((element) => {
            // Extract the size as a key.
            var key = element.Size;

            // Create an item object with the variety code and total kg.
            var item = {
              VarietyCode: element.Variety,
              TotalKg: element.VarietyKg,
            };

            // Add the size kg to the item object using the size as the key.
            item[key] = element.SizeKg;

            this.dataSource.byKey(item.VarietyCode).then((res) => {
              if (res.TotalKg) {
                res[key] = (res.TotalKg * item[key]) / item.TotalKg;
                // Update the data source with the new item.
                this.dataSource.update(res.VarietyCode, res);
              }
            });
          });

          // Get the instance of the data grid component.
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;

          // If the data grid exists, refresh it.
          if (dataGrid)
            dataGrid.refresh(true).then(() => {
              // // Initialize a total variable.
              // var total = 0;
              // // Iterate over each data in the data source array.
              // this.dataSource._array.forEach((data) => {
              //   // console.log("AA >> ", data.TotalKg);
              //   // Add the total kg to the total variable.
              //   if (data.TotalKg) total = total + data.TotalKg;
              // });
              // // Update the total kgs.
              // this.updateTotalKgs(undefined, Math.round(total));
            });

          // Hide the loading indicator.
          this.showLoading(false);

          // Close the apply size profile modal.
          this.closeApplySizeProfile();
        })
        .catch((err) => {
          // If an error occurs, hide the loading indicator.
          if (err) this.showLoading(false);
        });
    },
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),

    getApplySizeProfileFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              screenField: "EstimateSeason",
              dataField: "Season",
              editorType: "dxSelectBox",
              required: true,
              editorOptions: {
                tabIndex: 2,
                dataSource: IntakeSeasonService.dataSourceConfig(
                  "api/AlmondcoIntakeSeason",
                  {
                    select: ["Season", "RecordId", "StartDate", "EndDate"],
                    sort: "Season asc",
                  }
                ),
                displayExpr: "Season",
                valueExpr: "Season",
                searchExpr: ["Season"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                dropDownOptions: {
                  minWidth: 200,
                },
                onItemClick: this.onSeasonClicked,
              },
            },
          ],
        },
      ];
    },
    ApplySizeProfileConfig() {
      return {
        save: {
          text: "Apply",
          disabled: !this.ApplySizeProfileModel.Season,
          clickCallback: async () => {
            await this.onApplySizeProfile();
          },
        },
        back: {
          text: "Cancel",
          clickCallback: async () => {
            this.closeApplySizeProfile();
          },
        },
      };
    },
    getGridHeight() {
      return this.gridHeight - 20 - 55 - this.headerFormHeight;
    },
    getDataSource() {
      return this.dataSource._array;
    },
    getColumns() {
      return [
        {
          caption: "Variety",
          dataField: "VarietyCode",
          fixed: true,
          allowEditing: false,
          minWidth: 85,
          sortIndex: 0,
          sortOrder: "asc",
        },
        {
          caption: "Start",
          dataField: "StartDate",
          allowEditing: true,
          dataType: "date",
          format: "dd MMM yyyy",
          editorOptions: {
            displayFormat: "dd MMM yyyy",
            useMaskBehavior: true,
            showClearButton: true,
          },
          width: 110,
          setCellValue: (newData, value) => {
            newData.StartDate = value;
            return newData;
          },
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
        },
        {
          caption: "End",
          dataField: "EndDate",
          allowEditing: true,
          dataType: "date",
          format: "dd MMM yyyy",
          editorOptions: {
            displayFormat: "dd MMM yyyy",
            useMaskBehavior: true,
            showClearButton: true,
          },
          width: 110,
          setCellValue: (newData, value) => {
            newData.EndDate = value;
            return newData;
          },
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
        },
        {
          caption: "Lift %",
          dataField: "LiftPcnt",
          dataType: "number",
          allowEditing: true,
          width: 110,
          setCellValue: (newData, value) => {
            newData.LiftPcnt = value;
            return newData;
          },
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
          editorOptions: {
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
          },
        },
        {
          caption: "Total",
          dataField: "TotalKg",
          dataType: "number",
          allowEditing: true,
          minWidth: 110,
          setCellValue: (newData, value, currentRowData) => {
            // Set the TotalKg of newData to the provided value
            newData.TotalKg = value;

            // Iterate over each property in currentRowData
            for (var key in currentRowData) {
              // Skip the properties "VarietyCode", "StartDate", "EndDate", "LiftPcnt", and "TotalKg"
              if (
                key != "VarietyCode" &&
                key != "StartDate" &&
                key != "EndDate" &&
                key != "LiftPcnt" &&
                key != "TotalKg"
              ) {
                // If the TotalKg of currentRowData is not zero
                if (currentRowData.TotalKg < 0 || currentRowData.TotalKg > 0) {
                  // If the current property value is greater than zero
                  if (currentRowData[key] > 0)
                    // Update the current property in newData by multiplying the ratio of new and old TotalKg with the current property value
                    newData[key] =
                      (newData.TotalKg / currentRowData.TotalKg) *
                      currentRowData[key];
                }
              }
            }

            // Update the total kilograms with the old and new TotalKg
            this.updateTotalKgs(currentRowData.TotalKg, newData.TotalKg);

            // Return the updated newData
            return newData;
          },
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
          format: "##,###,###,###,##0",
          editorOptions: {
            format: "##,###,###,###,##0",
            onFocusIn: (e) => {
              if (e.event.target.select) e.event.target.select();
            },
          },
        },
      ].concat(this.columns);
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "EstimateSeason",
                  dataField: "Season",
                  editorType:
                    this.baseView.mode == "review"
                      ? "dxTextBox"
                      : "dxSelectBox",
                  required: true,
                  editorOptions: {
                    tabIndex: 2,
                    dataSource: IntakeSeasonService.dataSourceConfig(
                      "api/AlmondcoIntakeSeason",
                      {
                        select: ["Season", "RecordId", "StartDate", "EndDate"],
                        sort: "Season asc",
                      }
                    ),
                    displayExpr: "Season",
                    valueExpr: "Season",
                    searchExpr: ["Season"],
                    searchMode: "contains",
                    showClearButton: true,
                    searchEnabled: true,
                    dropDownOptions: {
                      minWidth: 500,
                    },
                    onItemClick: this.onSeasonClicked,
                  },
                },
                {
                  screenField: "EstimateDate",
                  dataField: "EstimateDate",
                  required: true,
                  editorOptions: {
                    tabIndex: 3,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "EstimateOwner",
                  dataField: "EstimateOwner",
                  required: true,
                  editorOptions: {
                    tabIndex: 4,
                    onFocusIn: (e) => {
                      if (e.event.target.select) e.event.target.select();
                    },
                  },
                },
                {
                  screenField: "TotalKg",
                  dataField: "TotalKg",
                  editorType: "dxNumberBox",
                  required: true,
                  format: "##,###,###,###,##0",
                  editorOptions: {
                    format: "##,###,###,###,##0",
                    tabIndex: 5,
                    onFocusIn: (e) => {
                      if (e.event.target.select) e.event.target.select();
                    },
                    onValueChanged: (e) => {
                      // Check if the event exists
                      if (e.event) {
                        // Iterate over each element in the dataSource array
                        this.dataSource._array.forEach((element) => {
                          // Iterate over each property in the current element
                          for (var key in element) {
                            // Skip the properties "VarietyCode", "StartDate", "EndDate", and "LiftPcnt"
                            if (
                              key != "VarietyCode" &&
                              key != "StartDate" &&
                              key != "EndDate" &&
                              key != "LiftPcnt"
                            ) {
                              // If the previous value is not zero
                              if (e.previousValue != 0) {
                                // If the current property value is greater than zero
                                if (element[key] > 0) {
                                  // Update the current property by multiplying the ratio of new and old values with the current property value
                                  element[key] =
                                    (e.value / e.previousValue) * element[key];
                                }
                              }
                            }

                            // Update the current element in the dataSource
                            this.dataSource.update(
                              element.VarietyCode,
                              element
                            );
                          }
                        });

                        // Get the instance of the data grid component
                        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

                        // If dataGrid exists - Refresh the data grid
                        if (dataGrid) dataGrid.refresh(true);
                      }
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    getHeaderToolbar() {
      return {
        audit: this.baseView.mode == "review",
        status: false,
        notes: false,
        save: true,
        toolbarFormItems: [
          {
            screenField: "EstimateDescription",
            dataField: "Description",
            editorOptions: {
              tabIndex: 1,
              placeholder: "Description",
              maxLength: 100,
            },
            label: {
              text: "Description",
              visible: false,
            },
            required: true,
            visible: this.baseView.mode != "review",
          },
        ],
        ellipsis:
          this.baseView.mode == "edit"
            ? {
                menuItems: [{ menuText: "Apply Size Profile" }],
                visible: true,
                clickAction: (e) => {
                  if (e.itemData.menuText == "Apply Size Profile") {
                    this.openApplySizeProfile();
                  }
                },
              }
            : undefined,
      };
    },
  },
};
</script>


<style lang="scss">
.intake-estimate {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row .dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
  .gc-editable-cell-color[role="gridcell"]:not(.cell-disabled) {
    background-color: #f8fdfe !important;
    // #d1f7ffba !important
  }
}
</style>